/* ============================================================
   Google Consent Mode v2 - Avada Cookie Bar integration
   ------------------------------------------------------------
   BASELINE / PLACEHOLDER.

   This sets Consent Mode v2 to "denied" by default (the
   privacy-safe state) before any Google tag (GTM / GA4 / Google
   Ads) fires. It is loaded as early as possible from <head> in
   every layout.

   TO COMPLETE THE INTEGRATION:
   1. In the Avada Cookie Bar app: Integrations (GCM V2, TikTok,
      Pixel) > Google Consent Mode V2 > Turn on.
   2. Replace the contents of THIS file with Avada's official
      `avada-cookiebar-gcm-integration.js` (provided by the app).
      Avada's file adds the banner -> consent "update" bridge, so
      tracking is GRANTED when a visitor accepts in the cookie bar.
      Keep the same filename so the <script> tags keep working.

   Doc: https://docs.avada.io/cookie-help-center/integrations/integrate-with-google-consent-mode
   ============================================================ */
(function () {
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }
  if (!window.gtag) { window.gtag = gtag; }

  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'granted',
    wait_for_update: 500
  });

  gtag('set', 'ads_data_redaction', true);
  gtag('set', 'url_passthrough', true);
})();
